"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var STATE_VARIABLES = {
  shared_component: 'hotel_shared_component',
  all_stations: 'hotel_all_stations',
  data_format_date: 'hotel_data_format_date',
  base_currency: 'hotel_base_currency',
  multi_currency: 'hotel_multi_currency',
  search_deep_link_data: 'hotel_search_deep_link_data',
  nearest_airports: 'hotel_nearest_airports',
  destinations: 'hotel_destinations',
  updated_state: 'hotel_updated_state',
  channel: 'hotel_channel',
  aoc: 'hotel_aoc',
  feature_flag: 'hotel_feature_flag',
  config: 'hotel_config',
  product_tiles: 'hotel_product_tiles',
  suggestions: 'hotel_suggestions',
  suggestion: 'hotel_suggestion'
};
var _default = STATE_VARIABLES;
exports["default"] = _default;